module.exports = __webpack_public_path__ + "static/port-dfc019fd9c076bfe8f614e48ed557a4e.jpg";